// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../src/assets/fonts/AvenirRegular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Avenir";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

.right-panel {
    width: 100%;
    height: 100%;
    min-height: 99%;
    overflow-y: auto;
    overflow-x: hidden;
    background: #f5f5f5;
    border-left: 2px solid #e1e1e3;
    padding: 5px;
    box-sizing: border-box;
    height: calc(100vh - 60px);
}

.tabs {
    display: flex;
    align-items: center;
    gap: 23px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 5px;
}

.tab {
    font-size: 12px;
    color: #444;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: bold !important;
    width: 100%;
}

.tab.active {
    background: #f2dfd5;
    padding: 6px 10px;
    border-radius: 8px;
    font-weight: 500;
}

.line-title {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 0px 0;
    font-size: 13px;
    color: #333;
}

.line-title::before,
.line-title::after {
    content: "";
    flex: 1 1;
    height: 1px;
    background: #ccc;
}

.line-title::before {
    margin-right: 10px;
}

.line-title::after {
    margin-left: 10px;
}

.line-title span {
    background: #f5f5f5;
    padding: 4px 12px;
    border-radius: 12px;
    border: 1px solid #d8d7d7;
    color: #333;
    font-size: 13px;
    cursor: pointer;
    font-family: Avenir !important;
    text-transform: lowercase;
}

.list {
    padding: 5px;
    border-radius: 6px;
}

.row {
    width: 100%;
    background: #dcdfe3;
    border-radius: 4px;
    margin-bottom: 10px;
    overflow: hidden;
}

.fill {
    background: #1c3b52;
    color: #fff;
    padding: 3px 5px;
    font-size: 12px;
    border-radius: 4px;
    width: 0;
    transition: width 0.4s ease;
}

.list+.line-title {
    margin-top: 0px;
}

.line-title span:active {
    background: #ed6926;
}

@media (max-width: 768px) {
    .right-panel {
        height: auto;
        padding: 5px 0px 0px 5px;
        margin-top: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/rightPanel.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,+DAAuE;AAC3E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,SAAO;IACP,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,eAAe;IACf,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;QACZ,wBAAwB;QACxB,gBAAgB;IACpB;AACJ","sourcesContent":["@font-face {\n    font-family: \"Avenir\";\n    src: url(\"../../src/assets/fonts/AvenirRegular.ttf\") format(\"truetype\");\n}\n\n.right-panel {\n    width: 100%;\n    height: 100%;\n    min-height: 99%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background: #f5f5f5;\n    border-left: 2px solid #e1e1e3;\n    padding: 5px;\n    box-sizing: border-box;\n    height: calc(100vh - 60px);\n}\n\n.tabs {\n    display: flex;\n    align-items: center;\n    gap: 23px;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 5px;\n    margin-bottom: 5px;\n}\n\n.tab {\n    font-size: 12px;\n    color: #444;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: bold !important;\n    width: 100%;\n}\n\n.tab.active {\n    background: #f2dfd5;\n    padding: 6px 10px;\n    border-radius: 8px;\n    font-weight: 500;\n}\n\n.line-title {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    margin: 0px 0;\n    font-size: 13px;\n    color: #333;\n}\n\n.line-title::before,\n.line-title::after {\n    content: \"\";\n    flex: 1;\n    height: 1px;\n    background: #ccc;\n}\n\n.line-title::before {\n    margin-right: 10px;\n}\n\n.line-title::after {\n    margin-left: 10px;\n}\n\n.line-title span {\n    background: #f5f5f5;\n    padding: 4px 12px;\n    border-radius: 12px;\n    border: 1px solid #d8d7d7;\n    color: #333;\n    font-size: 13px;\n    cursor: pointer;\n    font-family: Avenir !important;\n    text-transform: lowercase;\n}\n\n.list {\n    padding: 5px;\n    border-radius: 6px;\n}\n\n.row {\n    width: 100%;\n    background: #dcdfe3;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    overflow: hidden;\n}\n\n.fill {\n    background: #1c3b52;\n    color: #fff;\n    padding: 3px 5px;\n    font-size: 12px;\n    border-radius: 4px;\n    width: 0;\n    transition: width 0.4s ease;\n}\n\n.list+.line-title {\n    margin-top: 0px;\n}\n\n.line-title span:active {\n    background: #ed6926;\n}\n\n@media (max-width: 768px) {\n    .right-panel {\n        height: auto;\n        padding: 5px 0px 0px 5px;\n        margin-top: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
